
import { defineStore } from 'pinia';
import { ref, type Ref } from 'vue';
import get from './get';
import put from './put';

export const useLocalStorageStore = defineStore('localstorage', () => {
  const prefix:Ref<string> = ref('');
  return {
    prefix: 'app',
    get(key: string, defaultValue: any): any {
      return get(key, defaultValue, prefix.value);
    },
    put(key: string, value: any): void {
      return put(key, value, prefix.value);
    }
  }
});
